import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"

export default class HuddleAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  // Huddle
  Huddle_Yesterday_Today = ApiRoutes.Huddle.Huddle_Yesterday_Today
  HuddleEditHours = ApiRoutes.Huddle.HuddleEditHours
  huddleSummary = ApiRoutes.Huddle.HuddleSummary
  huddleSummaryKeyMetrics = ApiRoutes.Huddle.HuddleSummaryKeyMetrics
  huddleActiveOpportunities = ApiRoutes.Huddle.HuddleActiveOpportunities
  providerSummary = ApiRoutes.Huddle.ProviderSummary
  huddleTodayAudit = ApiRoutes.Huddle.HuddleTodayAudit
  huddleYesterdayAudit = ApiRoutes.Huddle.HuddleYesterdayAudit
  huddleTomorrowAudit = ApiRoutes.Huddle.HuddleTomorrowAudit

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  getHuddleByPratice = (token: string, practice_sk: any) => {
    return this.instance({
      method: this.Huddle_Yesterday_Today.Method,
      url: this.Huddle_Yesterday_Today.EndPoint(practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getHuddleSummaryByPratice = (token: string, practice_sk: any) => {
    return this.instance({
      method: this.huddleSummary.Method,
      url: this.huddleSummary.EndPoint(practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getHuddleSummaryKeyMetricsByPratice = (token: string, practice_sk: any) => {
    return this.instance({
      method: this.huddleSummaryKeyMetrics.Method,
      url: this.huddleSummaryKeyMetrics.EndPoint(practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getHuddleActiveOpportunitiesByPratice = (token: string, practice_sk: any) => {
    return this.instance({
      method: this.huddleActiveOpportunities.Method,
      url: this.huddleActiveOpportunities.EndPoint(practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getProviderSummaryByPratice = (token: string, practice_sk: any) => {
    return this.instance({
      method: this.providerSummary.Method,
      url: this.providerSummary.EndPoint(practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getHuddleTodayAuditByPratice = (token: string, practice_sk: any) => {
    return this.instance({
      method: this.huddleTodayAudit.Method,
      url: this.huddleTodayAudit.EndPoint(practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getHuddleYesterdayAuditByPratice = (token: string, practice_sk: any) => {
    return this.instance({
      method: this.huddleYesterdayAudit.Method,
      url: this.huddleYesterdayAudit.EndPoint(practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getHuddleTomorrowAuditByPratice = (token: string, practice_sk: any) => {
    return this.instance({
      method: this.huddleTomorrowAudit.Method,
      url: this.huddleTomorrowAudit.EndPoint(practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  EditHuddleByHours = (token: string, data: any) => {
    return this.instance({
      method: this.HuddleEditHours.Method,
      url: this.HuddleEditHours.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    })
  }
}
